module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABHNCSVQICAgIfAhkiAAAAKlJREFUaIHt1SEOAjEQRuF/9jQ4JFfBoEFxGBRozF4FieM2g9jsJiuWabpi0uV9qm0qpkmTJwEAAPwvGxfP+23vpt6kXeZAMX/J7Xy6XN+S1E3HTQwvSXaQ+WPcdb+utmB6gLmOLn0yhykzfKHsKQBgYNGFvELPi7skDFleoefFXbKdEi/JKzTFBdCCsMSR+lKXlTayOmT1pS4rbWT7JY7Ul5rSAgAArPUFI0E5FgkhKtgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zone/img35.png
// module id = e7h5
// module chunks = 1